import React, { useEffect } from 'react';
import './footer.css';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

function Footer() {
    const animation = useAnimation();
    const [featuredRef, inView] = useInView({
        triggerOnce: true,
        rootMargin: '-100px'
    });
    useEffect(() => {
        if(inView) {
            animation.start("visible")
        }
    }, [animation, inView])
    const animation2 = useAnimation();
    const [featuredRef2, inView2] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView2) {
            animation2.start("visible")
        }
    }, [animation2, inView2])

    const animation3 = useAnimation();
    const [featuredRef3, inView3] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView3) {
            animation3.start("visible")
        }
    }, [animation3, inView3])
    const animation4 = useAnimation();
    const [featuredRef4, inView4] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView4) {
            animation4.start("visible")
        }
    }, [animation4, inView4])
    return (
        <div className="footer">
            <div className="footer__div2">
                <div className="footer__div3">
                    <motion.div ref={featuredRef} animate={animation} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0}}, hidden: {y: 70, opacity: 0}}} className="footer__div4">
                        <h3 className="about1">Contact</h3>
                    </motion.div>
                    <div className="footer__div5">
                        <motion.div ref={featuredRef2} animate={animation2} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0}}, hidden: {y: 70, opacity: 0}}}  className="footer__div6">
                            <h1>SEND</h1>
                        </motion.div>
                        <motion.div ref={featuredRef3} animate={animation3} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0}}, hidden: {y: 70, opacity: 0}}}  className="footer__div7">
                            <h1>YOUR</h1>
                        </motion.div>
                        <motion.div ref={featuredRef4} animate={animation4} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0}}, hidden: {y: 70, opacity: 0}}}  className="footer__div8">
                            <h1>REQUEST</h1>
                        </motion.div>
                    </div>
                </div>
                <motion.div className="footer__div13">
                    <div className="footer__div14">
                        <ArrowDownwardIcon />
                    </div>
                </motion.div>
                <div className="footer__div9">
                    <div className="footer__div10">
                        <div className="footer__div11">
                            <img className="footer__img1" src="https://assets.website-files.com/5fbe1360b0b0b404ff90d2e7/5fbe53bb8416f60320b85cab_Igor.gif" />
                        </div>
                        <div className="footer__div12">
                            <h1 className="footer__line1">Kazuo Kaze</h1>
                            <h2 className="footer__line2">Mumbai, India</h2>
                            <h2 className="footer__line2">kazuokaze0@gmail.com</h2>
                        </div>
                    </div>
                    <div className="footer__div15">
                        <div className="footer__div11">
                            <img className="footer__img1" src="https://assets.website-files.com/5fbe1360b0b0b404ff90d2e7/5fbe53be95273e26e4b6c7bf_Xenia.gif" />
                        </div>
                        <div className="footer__div12">
                            <h1 className="footer__line1">Radius Studio</h1>
                            <h2 className="footer__line2">Mumbai, India</h2>
                            <h2 className="footer__line2">radiuswebstudio@gmail.com</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
